import "./about.css";
import Award from "../../img/award.png";

const About = () => {
  return (
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img
            src="/coding.jpeg"
            alt=""
            className="a-img"
          />
        </div>
      </div>
      <div className="a-right">
        <h1 className="a-title">About Me</h1>
        <p className="a-sub">
          I am a sofware developer with about 6 years experience writing code and 5 years professional experience. 
        </p>
        <p className="a-desc">
         I have experience working with startups and corporations and building their entreprise software and applications as well as building applications for their large client base
        </p>
        <div className="a-award">
          <img src={Award} alt="" className="a-award-img" />
          <div className="a-award-texts">
            <h4 className="a-award-title">1st position ICreate Mobile App Hackathon</h4>
            <p className="a-award-desc">
             Won the inaugural iCreate hackathon for the mobile app division.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
